export enum LocalAtendimentoEnum {
  CONCESSIONARIA = "Concessionária",
  DOMICILIO = "Domicílio",
}
